
export default {
  className: 'shopType',
  defaultOrder: '-weight',
  render: (record) => {
    let stringFields = ['name']
    return stringFields.map(f => record[f]).join('-')
  },
  fields: [
    {
      name: 'cover',
      validators: [
        (val) => val ? null : '分类封面不可为空'
      ]
    },
    {
      name: 'name',
      validators: [
        (val) => val ? null : '分类名称不可为空',
        (val) => val.length <= 4 ? null : '分类名称长度不可超过4个字符'
      ]
    }
  ],
  search: [
    'name'
  ],
  action: {
    sorter: {
      type: 'list',
      icon: 'swap',
      text: '排序',
      component: 'akModelSorter'
    }
  }
}
